var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4, _ellipse5, _path5, _ellipse6, _path6, _ellipse7, _ellipse8, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 55,
    viewBox: "0 0 452 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6902,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3037 40.6306C9.50175 40.6306 0.762638 34.9035 2.14283 21.5816C3.86807 4.9292 11.8021 2.45187 16.9778 2.04571C22.1535 1.63956 35.3804 3.67033 35.3804 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.9646,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2138 40.6306C81.1383 40.6306 72.8591 34.9035 74.1667 21.5816C75.8011 4.9292 83.3175 2.45187 88.2209 2.04571C93.1242 1.63956 105.655 3.67033 105.655 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.239,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.853 40.6306C150.051 40.6306 141.311 34.9035 142.692 21.5816C144.417 4.9292 152.351 2.45187 157.527 2.04571C162.702 1.63956 175.929 3.67033 175.929 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.514,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.006 40.6306C219.93 40.6306 211.651 34.9035 212.959 21.5816C214.593 4.9292 222.11 2.45187 227.013 2.04571C231.916 1.63956 244.447 3.67033 244.447 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.031,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.523 40.6306C288.448 40.6306 280.169 34.9035 281.476 21.5816C283.111 4.9292 290.627 2.45187 295.531 2.04571C300.434 1.63956 312.965 3.67033 312.965 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.549,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.041 40.6306C356.966 40.6306 348.686 34.9035 349.994 21.5816C351.628 4.9292 359.145 2.45187 364.048 2.04571C368.951 1.63956 381.482 3.67033 381.482 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.067,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.067,
    cy: 43.7456,
    rx: 11.4196,
    ry: 10.5923,
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M438.559 40.6306C425.483 40.6306 417.204 34.9035 418.512 21.5816C420.146 4.9292 427.663 2.45187 432.566 2.04571C437.469 1.63956 450 3.67033 450 19.1043",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.bf48fa17a5cd71012ed3926e2f2d5bb5.svg";
export { ForwardRef as ReactComponent };